/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_PermissionsInputs */

const th_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิทธิ์ของคุณ (การแข่งขัน)`)
};

const en_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your permissions (event)`)
};

const ja_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの権限（大会）`)
};

const zh_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的权限（赛事）`)
};

const es_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus permisos (evento)`)
};

const pt_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas permissões (evento)`)
};

const id_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izin Anda (acara)`)
};

const fr_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos permissions (événement)`)
};

const tl_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga pahintulot mo (event)`)
};

const vi_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyền của bạn (sự kiện)`)
};

const ko_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 권한 (이벤트)`)
};

const de_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Berechtigungen (Event)`)
};

const ru_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши права (событие)`)
};

const tr_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzinleriniz (etkinlik)`)
};

const it_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi permessi (evento)`)
};

const pl_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje uprawnienia (wydarzenie)`)
};

const uk_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваші права (подія)`)
};

const hi_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी अनुमतियाँ (आयोजन)`)
};

const ar_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صلاحياتك (الفعالية)`)
};

const ms_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebenaran anda (acara)`)
};

const bn_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার অনুমতি (আয়োজন)`)
};

const zh_tw2_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的權限（賽事）`)
};

const zh_hk2_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的權限（賽事）`)
};

const ur_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کی اجازتیں (ایونٹ)`)
};

const fa_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجازه‌های شما (رویداد)`)
};

const sw_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhusa zako (tukio)`)
};

const nl_your_permissions = /** @type {(inputs: Your_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw rechten (evenement)`)
};

/**
* | output |
* | --- |
* | "Your permissions (event)" |
*
* @param {Your_PermissionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_permissions = /** @type {((inputs?: Your_PermissionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_PermissionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_permissions(inputs)
	if (locale === "ja") return ja_your_permissions(inputs)
	if (locale === "zh") return zh_your_permissions(inputs)
	if (locale === "es") return es_your_permissions(inputs)
	if (locale === "pt") return pt_your_permissions(inputs)
	if (locale === "id") return id_your_permissions(inputs)
	if (locale === "fr") return fr_your_permissions(inputs)
	if (locale === "tl") return tl_your_permissions(inputs)
	if (locale === "vi") return vi_your_permissions(inputs)
	if (locale === "ko") return ko_your_permissions(inputs)
	if (locale === "de") return de_your_permissions(inputs)
	if (locale === "ru") return ru_your_permissions(inputs)
	if (locale === "tr") return tr_your_permissions(inputs)
	if (locale === "it") return it_your_permissions(inputs)
	if (locale === "pl") return pl_your_permissions(inputs)
	if (locale === "uk") return uk_your_permissions(inputs)
	if (locale === "hi") return hi_your_permissions(inputs)
	if (locale === "ar") return ar_your_permissions(inputs)
	if (locale === "ms") return ms_your_permissions(inputs)
	if (locale === "bn") return bn_your_permissions(inputs)
	if (locale === "zh-TW") return zh_tw2_your_permissions(inputs)
	if (locale === "zh-HK") return zh_hk2_your_permissions(inputs)
	if (locale === "ur") return ur_your_permissions(inputs)
	if (locale === "fa") return fa_your_permissions(inputs)
	if (locale === "sw") return sw_your_permissions(inputs)
	if (locale === "nl") return nl_your_permissions(inputs)
	return en_your_permissions(inputs)
});